// extracted by mini-css-extract-plugin
export default {"errorText":"ErrorMessage_errorText__kyZMn"};